var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.5V7.56811C21.3617 7.94025 23.25 10.0867 23.25 12.8259C23.25 14.2917 22.7168 15.6721 21.7486 16.7131C21.2648 17.2391 20.6768 17.6585 20.0219 17.9447C19.3671 18.2308 18.6598 18.3774 17.9452 18.375H14.625V16.875H17.9452C20.0787 16.875 21.75 15.0964 21.75 12.8259C21.75 10.6431 20.169 9.03881 17.9906 9.01125L17.25 9.00187V7.5C17.25 6.10761 16.6969 4.77226 15.7123 3.78769C14.7277 2.80312 13.3924 2.25 12 2.25C10.6076 2.25 9.27226 2.80312 8.28769 3.78769C7.30312 4.77226 6.75 6.10761 6.75 7.5V8.97211L6.0533 9.02175C3.92063 9.17358 2.25 10.8446 2.25 12.8259C2.25 14.9829 4.17909 16.875 6.37828 16.875H9.375V18.375H6.37828C4.93772 18.375 3.50156 17.7785 2.43797 16.7385C1.34944 15.6741 0.75 14.2846 0.75 12.8259C0.750531 12.1402 0.888555 11.4617 1.15591 10.8303C1.42326 10.1989 1.81452 9.62754 2.30653 9.15C3.11503 8.35985 4.13912 7.82641 5.25 7.61677V7.5C5.25 3.77812 8.27813 0.75 12 0.75C15.7219 0.75 18.75 3.77812 18.75 7.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0017 9.12012L16.2294 13.3479L15.1688 14.4085L12.7517 11.9914V23.2504H11.2517V11.9914L8.83457 14.4085L7.77393 13.3479L12.0017 9.12012Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.43e7df16.svg";
export { ForwardRef as ReactComponent };